import script from "./ExchangeRecordList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExchangeRecordList.vue?vue&type=script&setup=true&lang=js"

import "./ExchangeRecordList.vue?vue&type=style&index=0&id=a3a070b2&lang=css"

const __exports__ = script;

export default __exports__